"use client";
import Icon from "../components/Icons";

// app/loading.js
export default function Loading({ noPage }) {
  const isAdmin =
    typeof window !== "undefined"
      ? window?.location?.href.includes("admin")
      : false;
  if (noPage) {
    return (
      <div className="flex w-full py-10 items-center justify-center">
        <Icon name="logo" size={50} />
      </div>
    );
  }
  if (isAdmin) {
    return (
      <div className="flex w-full h-[100vh] items-center justify-center">
        <Icon name="logo" size={50} />
      </div>
    );
  }
  return (
    <div className="flex w-full h-[100vh] items-center justify-center">
      <Icon name="logo" size={50} />
    </div>
  );
}
